import debug from 'debug';

export const getLogger = (ns: string, color?: string) => {
  const logger = debug(ns);
  if (color) {
    logger.color = color;
  }
  return (...args: unknown[]) => {
    return logger(ns, ...args);
  };
};
